import { render, staticRenderFns } from "./OrderFormsView.vue?vue&type=template&id=3c485e54&lang=pug"
import script from "./OrderFormsView.vue?vue&type=script&lang=ts"
export * from "./OrderFormsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c485e54')) {
      api.createRecord('3c485e54', component.options)
    } else {
      api.reload('3c485e54', component.options)
    }
    module.hot.accept("./OrderFormsView.vue?vue&type=template&id=3c485e54&lang=pug", function () {
      api.rerender('3c485e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/OrderForms/OrderFormsView.vue"
export default component.exports